const SuggestionItem = (suggestion) => {
  /* eslint-disable camelcase */
  const { id, description, main_text, secondary_text } = suggestion;
  return `<li data-id="${id}" data-description="${description}"><span>${main_text}</span>${secondary_text}</li>`;
  /* eslint-enable camelcase */
};

export default SuggestionItem;
